import { appURLs } from "@/app/constants.mjs";
import {
  RANK_SYMBOL_TO_STR,
  REGION_LIST,
} from "@/game-lol/constants/constants.mjs";
import TftColors from "@/game-tft/colors.mjs";
import stringsToSymbols from "@/util/strings-to-symbols.mjs";
import SymbolMap from "@/util/symbol-map.mjs";

export const MATCH_LIMIT = 20;
export const PROBUILDS_MATCH_LENGTH = 25;

export const divisionToNumber = { I: 1, II: 2, III: 3, IV: 4 };

export const topRanks = ["CHALLENGER", "GRANDMASTER", "MASTER"];

export const sortedRanks = [
  ...topRanks,
  "DIAMOND",
  "EMERALD",
  "PLATINUM",
  "GOLD",
  "SILVER",
  "BRONZE",
  "IRON",
];

export const tftSetsDropdown = {
  // set4: 'Set 4: Fates',
  // set4_5: 'Set 4.5: Festival of Beasts',
  // set5: 'Set 5: Reckoning',
  // set5_5: 'Set 5.5: Dawn of Heroes',
  // set6: "Set 6: Gizmos & Gadgets",
  // set6_5: "Set 6.5: Neon Nights",
  // set7: "Set 7: Dragonlands",
  // set7_5: "Set 7.5: Uncharted Realms",
  // set8: "Set 8: Monsters Attack",
  // set8_5: "Set 8.5: Glitched Out",
  // set9: "Set 9: Runeterra Reforged",
  // set9_5: "Set 9.5: Horizonbound",
  // set3_5: "Set 3.5 Revival: Galaxies",
  // set10: "Set 10: Remix Rumble",
  // set11: "Set 11: Inkborn Fables",
  // set12: "Set 12: Magic n' Mayhem",
  // set5_5: "Set 5.5 Revival: Dawn of Heroes",
  // set4_5: "Set 4.5: Festival of Beasts",
  // set13: "Set 13: Into the Arcane",
  // set10: "Set 10: Remix Rumble",
  // set14: "Set 14: Cyber City",
  set7_5: "Set 7.5 Revival: Uncharted Realms",
  set15: "Set 15: K.O. Coliseum",
};

// show placeholder for /stats pages
// values: "","set5"
export const COMPS_PLACEHOLDER_SET = "set16";
export const EARLY_COMPS_PLACEHOLDER = ["set16"];
export const STATS_PLACEHOLDER_SET = "";
export const DEFAULT_SET = "set15";

// Not real items, or are basic, non-completed items, or spatula items
export const ITEM_BLACKLIST = ["TFT_Item_EmptyBag"];

// Hide these items from unit item suggestions
export const ITEM_SUGGESTION_BLACKLIST = [];

export const CHAMP_BLACKLIST = (set) => {
  switch (set) {
    case "set3_5":
      return ["TFT3_SuperMech", "TFT3_BardMeep"];
    case "set4_5":
      return [
        "TFT4_AzirSoldier",
        "TFT4_FortuneProp",
        "TFT4_FortunePropBig",
        "TFT4_Galio",
        "TFT4_NPC_Nexus",
      ];
    case "set5_5":
      return [
        "TFT5_HeimerTurret",
        "TFT5_DraconicEgg",
        "TFT5_IvernMinion",
        "TFT5_MonstrosityAxe",
      ];
    case "set8_5":
      return ["TFT8_TrainingDummy", "TFT8_Zac", "154", "KSante"];
    case "set9":
      return ["TFT9_HeimerdingerTurret", "TFT9_THex"];
    case "set9_5":
      return [
        "TFT9_HeimerdingerTurret",
        "TFT9_THex",
        "TFT9_BaronNashor",
        "TFT9_VoidRemora",
        "TFT9_RiftHerald",
        "TFT9_VoidEgg",
      ];
    case "set10":
      return ["TFT10_DiscoBall"];
    case "set11":
      return [
        "TFT11_XayahRakanDummy",
        "TFTEvent5YR_SuperMech",
        "TFTEvent5YR_TrainerDragon",
        "TFTEvent5YR_Veigar",
      ];
    case "set12":
      return [
        "TFT12_EldritchBigVolibear",
        "TFT12_EldritchDaisy",
        "TFT12_EldritchMalphite",
        "TFT12_EldritchVolibear",
        "TFT12_WinterStatue",
        "TFT12_Yuumi",
        "TFT12_ZapTower",
        "TFT_ElderDragon",
      ];
    case "set13":
      return ["TFT13_JayceSummon", "TFT13_Sion"];
    case "set14":
      return [
        "TFT14_AnimaSquadMeep",
        "TFT14_AnnieTibbers",
        "TFT14_CypherProp",
        "TFT14_GoldenOxProp",
        "TFT14_HackedEgg",
        "TFT14_NPC_AurelionSol",
        "TFT14_NPC_Azir",
        "TFT14_NPC_AzirSoldier",
        "TFT14_NPC_Cannon",
        "TFT14_NPC_Drone",
        "TFT14_NPC_Super",
        "TFT14_SummonLevel2",
        "TFT14_SummonLevel4",
        "TFT14_Summon_Turret",
        "TFT14_Virus_Bloblet",
      ];
    case "set15":
      return ["TFT15_Galio"];
    default:
      return [
        "BabyDragon",
        "Daisy",
        "DraconicEgg",
        "TheMonstrosity",
        "TrainingDummy",
        "Voidspawn",
        "Wolf",
        "MechanicalScarab",
        "MechanicalBear",
        "MechanicalDragon",
        "MalzaharVoidling",
        "Tibbers",
        "HexTechDragon",
        "JadeStatue",
      ];
  }
};

// maps rito's false reported keys to the correct keys
export const CHAMP_KEY_MAP = {
  tft13_elise: "TFT13_Elise",
  tft13_jinx: "TFT13_Jinx",
  tft13_swain: "TFT13_Swain",
  tft15_kogmaw: "TFT15_KogMaw",
  tft15_leesin: "TFT15_LeeSin",
  tft15_rammus: "TFT15_Rammus",
  TFT15_RammusPB: "TFT15_Rammus",
  tft15_smolder: "TFT15_Smolder",
};

// hides from set update and overview pages
export const CHAMP_PREVIEW_BLACKLIST = {
  set11: ["TFT11_XayahRakanDummy", "TFT11_Kayle"],
};

export const HEX_ELEMENT_ITEMS = ["10201", "10202", "10203", "10204"];

export const QUEUE_SYMBOLS = stringsToSymbols([
  "rankedTft",
  "rankedTftTurbo",
  "rankedTftDoubleUp",
  "tftChonccTreasure",
  "tftPengusParty",
  "tftTockersTrials",
]);
export const QUEUE_SYMBOLS_TO_QUEUE_NAMES = new SymbolMap({
  [QUEUE_SYMBOLS.rankedTft]: "RANKED_TFT",
  [QUEUE_SYMBOLS.rankedTftTurbo]: "RANKED_TFT_TURBO",
  [QUEUE_SYMBOLS.rankedTftDoubleUp]: "RANKED_TFT_DOUBLE_UP",
  [QUEUE_SYMBOLS.tftChonccTreasure]: "CHONCC_TREASURE_TFT",
  [QUEUE_SYMBOLS.tftPengusParty]: "PENGUS_PARTY_TFT",
  [QUEUE_SYMBOLS.tftTockersTrials]: "TOCKERS_TRIALS_TFT",
});

export const QUEUE_SYMBOLS_TO_QUEUE_IDS = new SymbolMap({
  [QUEUE_SYMBOLS.rankedTft]: 1100,
  [QUEUE_SYMBOLS.rankedTftTurbo]: 1130,
  [QUEUE_SYMBOLS.rankedTftDoubleUp]: 1160,
  [QUEUE_SYMBOLS.tftPengusParty]: 6120,
  [QUEUE_SYMBOLS.tftTockersTrials]: 1220,
});

export const HYPER_ROLL_RANKS = {
  NONE: {
    key: "none",
    display: "None",
    color: "#fffff",
    t: ["common:rank.unranked", "Unranked"],
  },
  PURPLE_PLUS: {
    key: "purple+",
    display: "Purple+",
    color: "#9d48e0",
    t: ["tft:ranks.purplePlus", "Purple+"],
  },
  ORANGE: {
    key: "orange",
    display: "Hyper",
    color: "#efbf6c",
    t: ["tft:ranks.hyper", "Hyper"],
    threshold: {
      min: 4200,
      max: null,
    },
  },
  PURPLE: {
    key: "purple",
    display: "Purple",
    color: "#9d48e0",
    t: ["tft:ranks.purple", "Purple"],
    threshold: {
      min: 3400,
      max: 4199,
    },
  },
  BLUE: {
    key: "blue",
    display: "Blue",
    color: "#8DC1EC",
    t: ["tft:ranks.blue", "Blue"],
    threshold: {
      min: 2600,
      max: 3399,
    },
  },
  GREEN: {
    key: "green",
    display: "Green",
    color: "#A1D486",
    t: ["tft:ranks.green", "Green"],
    threshold: {
      min: 1400,
      max: 2599,
    },
  },
  GRAY: {
    key: "gray",
    display: "Gray",
    color: "#E3E5EA",
    t: ["tft:ranks.gray", "Gray"],
    threshold: {
      min: 0,
      max: 1399,
    },
  },
};

export const RANKED_TFT = "RANKED_TFT";
export const RANKED_TFT_DOUBLE_UP = "RANKED_TFT_DOUBLE_UP";
export const RANKED_TFT_PAIRS = "RANKED_TFT_PAIRS";
export const RANKED_TFT_TURBO = "RANKED_TFT_TURBO";
export const TFT_CHONCC_TREASURE = "CHONCC_TREASURE_TFT";

export const TFT_RANKED_QUEUES = [
  RANKED_TFT,
  RANKED_TFT_DOUBLE_UP,
  RANKED_TFT_PAIRS,
  RANKED_TFT_TURBO,
];

export const setUnitPrefixes = {
  set2: "TFT2_",
  set3: "TFT3_",
  set3_5: "TFT3b_",
  set4: "TFT4_",
  set4_5: "TFT4b_",
  set5: "TFT5_",
  set5_5: "TFT5_",
  set6: "TFT6_",
  set6_5: "TFT6b_",
  set7: "TFT7_",
  set7_5: "TFT7b_",
  set8: "TFT8_",
  set8_5: "TFT8b_",
  set9: "TFT9_",
  set9_5: "TFT9b_",
  set10: "TFT10_",
  set11: "TFT11_",
  set12: "TFT12_",
  set13: "TFT13_",
  set14: "TFT14_",
  set15: "TFT15_",
};

// TFT queues for Data Team BE
export const DataTftQueues = [
  { key: "NORMAL", value: "NORMAL_TFT", queueId: "1090" },
  { key: "RANKED", value: "RANKED_TFT", queueId: "1100" },
  { key: "HYPERROLL", value: "RANKED_TFT_TURBO", queueId: "1130" },
  { key: "DOUBLEUP", value: "RANKED_TFT_DOUBLE_UP", queueId: "1150" },
  { key: "REVIVAL", value: "REVIVAL", queueId: "6000" },
  { key: "CHONCC_TREASURE_TFT", value: "CHONCC_TREASURE_TFT", queueId: "1210" },
  { key: "PENGUS_PARTY_TFT", value: "PENGUS_PARTY_TFT", queueId: "6120" },
  // { key: "TOCKERS_TRIALS_TFT", value: "TOCKERS_TRIALS_TFT", queueId: "1220" },
];

export const revivalSets = [
  {
    set: "set7_5",
    queueId: "6100",
  },
];

export const isFutureSet = (set) => {
  if (isRevivalSet(set)) return false;
  const setDate = new Date(setDates.find((s) => s.set === set)?.date);
  return setDate ? setDate?.getTime() > Date.now() : null;
};

export const isRevivalSet = (set) => {
  return !!revivalSets.find((s) => s.set === set);
};

// Ensure the setDates array go in desc order by set & date
export const setDates = [
  { set: "set15", date: "2025-07-30 06:00:00" },
  { set: "set14", date: "2025-04-02 06:00:00" },
  { set: "set13", date: "2024-11-20 06:00:00" },
  { set: "set12", date: "2024-07-31 06:00:00" },
  { set: "set11", date: "2024-03-20 06:00:00" },
  { set: "set10", date: "2023-11-21 06:00:00" },
  { set: "set9_5", date: "2023-09-13 06:00:00" },
  { set: "set9", date: "2023-06-14 06:00:00" },
  { set: "set8_5", date: "2023-03-22 06:00:00" },
  { set: "set8", date: "2022-12-07 06:00:00" },
  { set: "set7_5", date: "2022-09-08 06:00:00" },
  { set: "set7", date: "2022-06-08 06:00:00" },
  { set: "set6_5", date: "2022-02-16 06:00:00" },
  { set: "set6", date: "2021-11-03 06:00:00" },
  { set: "set5_5", date: "2021-07-21 06:00:00" },
  { set: "set5", date: "2021-04-28 06:00:00" },
  { set: "set4_5", date: "2021-01-21 06:00:00" },
  { set: "set4", date: "2020-09-16 06:00:00" },
  { set: "set3", date: "2020-03-18 06:00:00" },
  { set: "set2", date: "2019-11-06 06:00:00" },
  { set: "set1", date: "2019-06-10 06:00:00" },
];

export function getCurrentSet() {
  return (
    setDates.find(({ date }) => new Date(date).getTime() < Date.now())?.set ||
    DEFAULT_SET
  );
}

export const setTraitPrefixes = {
  set2: "Set2_",
  set3: "Set3_",
  set3_5: "Set3_", // Revival
  set4: "Set4_",
  set4_5: "Set4_",
  set5: "Set5_",
  set5_5: "Set5_",
  set6: "Set6_",
  set6_5: "Set6_",
  set7: "Set7_",
  set7_5: "TFT7_",
  set8: "Set8_",
  set8_5: "Set8_",
  set9: "Set9_",
  set9_5: "Set9_",
  set10: "TFT10_",
  set11: "TFT11_",
};

/* map patch to set */
export const setPatches = {
  // "12.20": "set7_5",
  // 12.21: "set7_5",
  // 12.22: "set7_5",
  // 12.23: "set8",
  // 13.1: "set8",
  // 13.2: "set8",
  // 13.3: "set8",
  // 13.4: "set8",
  // 13.5: "set8",
  // 13.6: "set8_5",
  // 13.7: "set8_5",
  // 13.8: "set8_5",
  // 13.9: "set8_5",
  // "13.10": "set8_5",
  // 13.11: "set8_5",
  // 13.12: "set9",
  // 13.13: "set9",
  // 13.14: "set9",
  // 13.15: "set9",
  // 13.16: "set9",
  // 13.17: "set9",
  // 13.18: "set9_5",
  // 13.19: "set9_5",
  // "13.20": "set9_5",
  // 13.21: "set9_5",
  // 13.22: "set9_5",
  // 13.23: "set10",
  // 13.24: "set10",
  // 14.1: "set10",
  // 14.2: "set10",
  // 14.3: "set10",
  // 14.4: "set10",
  // 14.5: "set10",
  // 14.6: "set11",
  // 14.7: "set11",
  // 14.8: "set11",
  // 14.9: "set11",
  // "14.10": "set11",
  // 14.11: "set11",
  // 14.12: "set11",
  // 14.13: "set11",
  // 14.14: "set11",
  // 14.15: "set12",
  // 14.16: "set12",
  // 14.17: "set12",
  // 14.18: "set12",
  // 14.19: "set12",
  // "14.20": "set12",
  // 14.21: "set12",
  // 14.22: "set12",
  // 14.23: "set13",
  // 14.24: "set13",
  // 15.1: "set13",
  // 15.2: "set13",
  // 15.3: "set13",
  // 15.4: "set13",
  // 15.5: "set13",
  // 15.6: "set13",
  // 15.7: "set14",
  // 15.8: "set14",
  // 15.9: "set14",
  // "15.10": "set14",
  // 15.11: "set14",
  // 15.12: "set14",
  15.13: "set14",
  15.14: "set14",
  15.15: "set15",
  15.16: "set15",
  15.17: "set15",
  15.18: "set15",
  15.19: "set15",
  "15.20": "set15",
  15.21: "set15",
  15.22: "set15",
  15.23: "set16",
  15.24: "set16",
};

export const TFTRounds = {
  1: {
    title: ["tft:rounds.roundOneTitle", "1: Carousel  |  2-4: Minions"],
    stages: [
      {
        num: 1,
        name: "Carousel",
        title: ["tft:carousel", "Carousel"],
        url: `${appURLs.CDN}/blitz/tft/postmatch/Carousel.png`,
      },
      {
        num: 2,
        name: "PVE",
        title: ["lol:pve", "PVE"],
        url: `${appURLs.CDN}/blitz/tft/postmatch/Minions.png`,
      },
      {
        num: 3,
        name: "PVE",
        title: ["lol:pve", "PVE"],
        url: `${appURLs.CDN}/blitz/tft/postmatch/Minions.png`,
      },
      {
        num: 4,
        name: "PVE",
        title: ["lol:pve", "PVE"],
        url: `${appURLs.CDN}/blitz/tft/postmatch/Minions.png`,
      },
    ],
  },
  2: {
    title: [
      "tft:rounds.roundTwoTitle",
      "1-3: Summoner  |  4: Carousel  |  5-6: Summoner  |  7: PVE",
    ],
    stages: [
      { num: 1, name: "PVP", title: ["common:pvp", "PVP"] },
      { num: 2, name: "PVP", title: ["common:pvp", "PVP"] },
      { num: 3, name: "PVP", title: ["common:pvp", "PVP"] },
      { num: 4, name: "PVP", title: ["common:pvp", "PVP"] },
      {
        num: 5,
        name: "Carousel",
        title: ["tft:carousel", "Carousel"],
        url: `${appURLs.CDN}/blitz/tft/postmatch/Carousel.png`,
      },
      { num: 6, name: "PVP", title: ["common:pvp", "PVP"] },
      {
        num: 7,
        name: "PVE",
        title: ["lol:pve", "PVE"],
        url: `${appURLs.CDN}/blitz/tft/postmatch/Minions.png`,
      },
    ],
  },
  3: {
    title: [
      "tft:rounds.roundThreeTitle",
      "1-3: Summoner  |  4: Carousel  |  5-6: Summoner  |  7: PVE",
    ],
    stages: [
      { num: 1, name: "PVP", title: ["common:pvp", "PVP"] },
      { num: 2, name: "PVP", title: ["common:pvp", "PVP"] },
      { num: 3, name: "PVP", title: ["common:pvp", "PVP"] },
      {
        num: 4,
        name: "Carousel",
        title: ["tft:carousel", "Carousel"],
        url: `${appURLs.CDN}/blitz/tft/postmatch/Carousel.png`,
      },
      { num: 5, name: "PVP", title: ["common:pvp", "PVP"] },
      { num: 6, name: "PVP", title: ["common:pvp", "PVP"] },
      {
        num: 7,
        name: "PVE",
        title: ["lol:pve", "PVE"],
        url: `${appURLs.CDN}/blitz/tft/postmatch/Minions.png`,
      },
    ],
  },
  4: {
    title: [
      "tft:rounds.roundFourTitle",
      "1-3: Summoner  |  4: Carousel  |  5-6: Summoner  |  7: PVE",
    ],
    stages: [
      { num: 1, name: "PVP", title: ["common:pvp", "PVP"] },
      { num: 2, name: "PVP", title: ["common:pvp", "PVP"] },
      { num: 3, name: "PVP", title: ["common:pvp", "PVP"] },
      {
        num: 4,
        name: "Carousel",
        title: ["tft:carousel", "Carousel"],
        url: `${appURLs.CDN}/blitz/tft/postmatch/Carousel.png`,
      },
      { num: 5, name: "PVP", title: ["common:pvp", "PVP"] },
      { num: 6, name: "PVP", title: ["common:pvp", "PVP"] },
      {
        num: 7,
        name: "PVE",
        title: ["lol:pve", "PVE"],
        url: `${appURLs.CDN}/blitz/tft/postmatch/Minions.png`,
      },
    ],
  },
  // 5-8
  5: {
    title: [
      "tft:rounds.roundFiveTitle",
      "1-3: Summoner  |  4: Carousel  |  5-6: Summoner  |  7: PVE",
    ],
    stages: [
      { num: 1, name: "PVP", title: ["common:pvp", "PVP"] },
      { num: 2, name: "PVP", title: ["common:pvp", "PVP"] },
      { num: 3, name: "PVP", title: ["common:pvp", "PVP"] },
      {
        num: 4,
        name: "Carousel",
        title: ["tft:carousel", "Carousel"],
        url: `${appURLs.CDN}/blitz/tft/postmatch/Carousel.png`,
      },
      { num: 5, name: "PVP", title: ["common:pvp", "PVP"] },
      { num: 6, name: "PVP", title: ["common:pvp", "PVP"] },
      {
        num: 7,
        name: "PVE",
        title: ["lol:pve", "PVE"],
        url: `${appURLs.CDN}/blitz/tft/postmatch/Minions.png`,
      },
    ],
  },
  // 9+
  9: {
    title: [
      "tft:rounds.roundNinTitle",
      "1-3: Summoner  |  4: Carousel  |  5-6: Summoner  |  7: PVE",
    ],
    stages: [
      { num: 1, name: "PVP", title: ["common:pvp", "PVP"] },
      { num: 2, name: "PVP", title: ["common:pvp", "PVP"] },
      { num: 3, name: "PVP", title: ["common:pvp", "PVP"] },
      {
        num: 4,
        name: "Carousel",
        title: ["tft:carousel", "Carousel"],
        url: `${appURLs.CDN}/blitz/tft/postmatch/Carousel.png`,
      },
      { num: 5, name: "PVP", title: ["common:pvp", "PVP"] },
      { num: 6, name: "PVP", title: ["common:pvp", "PVP"] },
      {
        num: 7,
        name: "PVE",
        title: ["lol:pve", "PVE"],
        url: `${appURLs.CDN}/blitz/tft/postmatch/Minions.png`,
      },
    ],
  },
};

// Calculate points based on the above normalized values
export const scoreWeights = {
  // Calculate points in champions
  champions: {
    multiply: {
      winRate: 5,
      avgPlacement: 20,
    },
    subtract: {
      avgPlacement: 0.8,
      top4Rate: 0.5,
      winRate: 3,
    },
  },
  // Calculate points in items
  items: {
    exponent: {
      matchesPlayed: 1.15,
      avgPlacement: 3,
      top4Rate: 5,
      winRate: 4,
    },
    multiply: {
      matchesPlayed: 90,
      avgPlacement: 60,
      top4Rate: 35,
      winRate: 35,
    },
  },
};

export const starTiers = {
  2: "Silver",
  3: "Gold",
  4: "Turq",
};

export const borderColors = {
  1: TftColors.placement.gradient[1],
  2: TftColors.placement.gradient[2],
  3: TftColors.placement.gradient[3],
  4: TftColors.placement.gradient[4],
};

export const titleColor = (rank) => {
  return `${TftColors.placement.solid[/[1-4]/.test(rank) ? rank : "default"]}`;
};

export const POSTMATCH_CAROUSEL = {
  ROUND_WIDTH: 66,
  ROUNDS_VIEWABLE: 12,
};

export const STATS_FILTER_DEFAULT = {
  sort: "avgplacement",
  tab: "stats",
  rank: RANK_SYMBOL_TO_STR[Object.getOwnPropertySymbols(RANK_SYMBOL_TO_STR)[0]]
    .key,
  region: REGION_LIST[0].key,
};

export const BASIC_ITEMS = [
  "TFT_Item_SparringGloves",
  "TFT_Item_BFSword",
  "TFT_Item_NeedlesslyLargeRod",
  "TFT_Item_RecurveBow",
  "TFT_Item_TearOfTheGoddess",
  "TFT_Item_ChainVest",
  "TFT_Item_NegatronCloak",
  "TFT_Item_GiantsBelt",
  "TFT_Item_Spatula",
  "TFT_Item_FryingPan",
];

export const THIEFS_GLOVES_ITEMS = [
  "TFT5_Item_ThiefsGlovesRadiant",
  "TFT_Item_ThiefsGloves",
  "TFT9_Item_OrnnPrototypeForge",
];

export const TRAIT_TRANSLATIONS = {
  alltraits: ["tft:traits.allTraits", "All Traits"],
  allclasses: ["tft:traits.allClasses", "All Classes"],
  allorigins: ["tft:traits.allOrigins", "All Origins"],
  flex: ["tft:flex", "Flex"],
  assassin: ["tft:traits.assassin", "Assassin"],
  blademaster: ["tft:traits.blademaster", "Blademaster"],
  brawler: ["tft:traits.brawler", "Brawler"],
  elementalist: ["tft:traits.elementalist", "Elementalist"],
  guardian: ["tft:traits.guardian", "Guardian"],
  gunslinger: ["tft:traits.gunslinger", "Gunslinger"],
  knight: ["tft:traits.knight", "Knight"],
  ranger: ["tft:traits.ranger", "Ranger"],
  shapeshifter: ["tft:traits.shapeshifter", "Shapeshifter"],
  sorcerer: ["tft:traits.sorcerer", "Sorcerer"],
  demon: ["tft:traits.demon", "Demon"],
  dragon: ["tft:traits.dragon", "Dragon"],
  exile: ["tft:traits.exile", "Exile"],
  glacial: ["tft:traits.glacial", "Glacial"],
  hextech: ["tft:traits.hextech", "Hextech"],
  imperial: ["tft:traits.imperial", "Imperial"],
  noble: ["tft:traits.noble", "Noble"],
  ninja: ["tft:traits.ninja", "Ninja"],
  pirate: ["tft:traits.pirate", "Pirate"],
  phantom: ["tft:traits.phantom", "Phantom"],
  robot: ["tft:traits.robot", "Robot"],
  void: ["tft:traits.void", "Void"],
  wild: ["tft:traits.wild", "Wild"],
  yordle: ["tft:traits.yordle", "Yordle"],
  yordlelord: ["tft:traits.yordlelord", "Yordle-Lord"],
  alchemist: ["tft:traits.alchemist", "Alchemist"],
  avatar: ["tft:traits.avatar", "Avatar"],
  berserker: ["tft:traits.berserker", "Berserker"],
  cloud: ["tft:traits.cloud", "Cloud"],
  crystal: ["tft:traits.crystal", "Crystal"],
  desert: ["tft:traits.desert", "Desert"],
  druid: ["tft:traits.druid", "Druid"],
  electric: ["tft:traits.electric", "Electric"],
  inferno: ["tft:traits.inferno", "Inferno"],
  light: ["tft:traits.light", "Light"],
  lunar: ["tft:traits.lunar", "Lunar"],
  mage: ["tft:traits.mage", "Mage"],
  steel: ["tft:traits.steel", "Steel"],
  mountain: ["tft:traits.mountain", "Mountain"],
  mystic: ["tft:traits.mystic", "Mystic"],
  ocean: ["tft:traits.ocean", "Ocean"],
  poison: ["tft:traits.poison", "Poison"],
  predator: ["tft:traits.predator", "Predator"],
  shadow: ["tft:traits.shadow", "Shadow"],
  soulbound: ["tft:traits.soulbound", "Soulbound"],
  summoner: ["tft:traits.summoner", "Summoner"],
  warden: ["tft:traits.warden", "Warden"],
  woodland: ["tft:traits.woodland", "Woodland"],
  astro: ["tft:traits.astro", "Astro"],
  battlecast: ["tft:traits.battlecast", "Battlecast"],
  blaster: ["tft:traits.blaster", "Blaster"],
  celestial: ["tft:traits.celestial", "Celestial"],
  chrono: ["tft:traits.chrono", "Chrono"],
  cybernetic: ["tft:traits.cybernetic", "Cybernetic"],
  darkstar: ["tft:traits.darkstar", "Dark Star"],
  demolitionist: ["tft:traits.demolitionist", "Demolitionist"],
  infiltrator: ["tft:traits.infiltrator", "Infiltrator"],
  manareaver: ["tft:traits.manareaver", "Mana-Reaver"],
  mechpilot: ["tft:traits.mechpilot", "Mech-Pilot"],
  mercenary: ["tft:traits.mercenary", "Mercenary"],
  paragon: ["tft:traits.paragon", "Paragon"],
  protector: ["tft:traits.protector", "Protector"],
  rebel: ["tft:traits.rebel", "Rebel"],
  sniper: ["tft:traits.sniper", "Sniper"],
  spacepirate: ["tft:traits.spacepirate", "Space Pirate"],
  starguardian: ["tft:traits.starguardian", "Star Guardian"],
  starship: ["tft:traits.starship", "Starship"],
  valkyrie: ["tft:traits.valkyrie", "Valkyrie"],
  vanguard: ["tft:traits.vanguard", "Vanguard"],
  adept: ["tft:traits.adept", "Adept"],
  master: ["tft:traits.adept", "Adept"],
  cultist: ["tft:traits.cultist", "Cultist"],
  dazzler: ["tft:traits.dazzler", "Dazzler"],
  divine: ["tft:traits.divine", "Divine"],
  duelist: ["tft:traits.duelist", "Duelist"],
  dusk: ["tft:traits.dusk", "Dusk"],
  elderwood: ["tft:traits.wilderness", "Elderwood"],
  emperor: ["tft:traits.emperor", "Emperor"],
  enlightened: ["tft:traits.enlightened", "Enlightened"],
  fortune: ["tft:traits.fortune", "Fortune"],
  hunter: ["tft:traits.hunter", "Hunter"],
  keeper: ["tft:traits.keeper", "Keeper"],
  moonlight: ["tft:traits.moonlight", "Moonlight"],
  shade: ["tft:traits.shade", "Shade"],
  sharpshooter: ["tft:traits.sharpshooter", "Sharpshooter"],
  spirit: ["tft:traits.spirit", "Spirit"],
  theboss: ["tft:traits.theboss", "The Boss"],
  boss: ["tft:traits.boss", "The Boss"],
  tormented: ["tft:traits.tormented", "Tormented"],
  warlord: ["tft:traits.warlord", "Warlord"],
  blacksmith: ["tft:traits.blacksmith", "Blacksmith"],
  daredevil: ["tft:traits.daredevil", "Daredevil"],
  dragonsoul: ["tft:traits.dragonsoul", "Dragonsoul"],
  executioner: ["tft:traits.executioner", "Executioner"],
  fabled: ["tft:traits.fabled", "Fabled"],
  slayer: ["tft:traits.slayer", "Slayer"],
  syphoner: ["tft:traits.syphoner", "Syphoner"],
  abomination: ["tft:traits.abomination", "Abomination"],
  caretaker: ["tft:traits.caretaker", "Caretaker"],
  cavalier: ["tft:traits.cavalier", "Cavalier"],
  coven: ["tft:traits.coven", "Coven"],
  cruel: ["tft:traits.cruel", "Cruel"],
  dawnbringer: ["tft:traits.dawnbringer", "Dawnbringer"],
  draconic: ["tft:traits.draconic", "Draconic"],
  dragonslayer: ["tft:traits.dragonslayer", "Dragonslayer"],
  eternal: ["tft:traits.eternal", "Eternal"],
  forgotten: ["tft:traits.forgotten", "Forgotten"],
  godking: ["tft:traits.godKing", "God-King"],
  hellion: ["tft:traits.hellion", "Hellion"],
  invoker: ["tft:traits.invoker", "Invoker"],
  ironclad: ["tft:traits.ironclad", "Ironclad"],
  legionnaire: ["tft:traits.legionnaire", "Legionnaire"],
  nightbringer: ["tft:traits.nightbringer", "Nightbringer"],
  redeemed: ["tft:traits.redeemed", "Redeemed"],
  revenant: ["tft:traits.revenant", "Revenant"],
  renewer: ["tft:traits.renewer", "Renewer"],
  skirmisher: ["tft:traits.skirmisher", "Skirmisher"],
  spellweaver: ["tft:traits.spellweaver", "Spellweaver"],
  verdant: ["tft:traits.verdant", "Verdant"],
  cannoneer: ["tft:traits.cannoneer", "Cannoneer"],
  inanimate: ["tft:traits.inanimate", "Inanimate"],
  sentinel: ["tft:traits.sentinel", "Sentinel"],
  victorious: ["tft:traits.victorious", "Victorious"],
  academy: ["tft:traits.academy", "Academy"],
  arcanist: ["tft:traits.arcanist", "Arcanist"],
  bodyguard: ["tft:traits.bodyguard", "Bodyguard"],
  bruiser: ["tft:traits.bruiser", "Bruiser"],
  challenger: ["tft:traits.challenger", "Challenger"],
  chemtech: ["tft:traits.chemtech", "Chemtech"],
  clockwork: ["tft:traits.clockwork", "Clockwork"],
  colossus: ["tft:traits.colossus", "Colossus"],
  cuddly: ["tft:traits.cuddly", "Cuddly"],
  enchanter: ["tft:traits.enchanter", "Enchanter"],
  enforcer: ["tft:traits.enforcer", "Enforcer"],
  glutton: ["tft:traits.glutton", "Glutton"],
  innovator: ["tft:traits.innovator", "Innovator"],
  mutant: ["tft:traits.mutant", "Mutant"],
  scholar: ["tft:traits.scholar", "Scholar"],
  scrap: ["tft:traits.scrap", "Scrap"],
  sister: ["tft:traits.sister", "Sister"],
  socialite: ["tft:traits.socialite", "Socialite"],
  syndicate: ["tft:traits.syndicate", "Syndicate"],
  transformer: ["tft:traits.transformer", "Transformer"],
  twinshot: ["tft:traits.twinshot", "Twinshot"],
  debonair: ["tft:traits.debonair", "Debonair"],
  mastermind: ["tft:traits.mastermind", "Mastermind"],
  rival: ["tft:traits.rival", "Rival"],
  striker: ["tft:traits.striker", "Striker"],
  astral: ["tft:traits.astral", "Astral"],
  bard: ["tft:traits.bard", "Bard"],
  dragonmancer: ["tft:traits.dragonmancer", "Dragonmancer"],
  evoker: ["tft:traits.evoker", "Evoker"],
  guild: ["tft:traits.guild", "Guild"],
  jade: ["tft:traits.jade", "Jade"],
  legend: ["tft:traits.legend", "Legend"],
  mirage: ["tft:traits.mirage", "Mirage"],
  ragewing: ["tft:traits.ragewing", "Ragewing"],
  revel: ["tft:traits.revel", "Revel"],
  scalescorn: ["tft:traits.scalescorn", "Scalescorn"],
  shimmerscale: ["tft:traits.shimmerscale", "Shimmerscale"],
  spellthief: ["tft:traits.spellthief", "Spell-Thief"],
  starcaller: ["tft:traits.starcaller", "Starcaller"],
  swiftshot: ["tft:traits.swiftshot", "Swiftshot"],
  tempest: ["tft:traits.tempest", "Tempest"],
  trainer: ["tft:traits.trainer", "Trainer"],
  warrior: ["tft:traits.warrior", "Warrior"],
  whispers: ["tft:traits.whispers", "Whispers"],
  darkflight: ["tft:traits.darkflight", "Darkflight"],
  lagoon: ["tft:traits.lagoon", "Lagoon"],
  monolith: ["tft:traits.monolith", "Monolith"],
  prodigy: ["tft:traits.prodigy", "Prodigy"],
  admin: ["tft:traits.admin", "A.D.M.I.N."],
  animasquad: ["tft:traits.animasquad", "Anima Squad"],
  arsenal: ["tft:traits.arsenal", "Arsenal"],
  civilian: ["tft:traits.civilian", "Civilian"],
  corrupted: ["tft:traits.corrupted", "Corrupted"],
  gadgeteen: ["tft:traits.gadgeteen", "Gadgeteen"],
  lasercorps: ["tft:traits.lasercorps", "LaserCorps"],
  mechaprime: ["tft:traits.mechaprime", "Mecha: Prime"],
  oxforce: ["tft:traits.oxforce", "Ox Force"],
  supers: ["tft:traits.supers", "Supers"],
  threat: ["tft:traits.threat", "Threat"],
  underground: ["tft:traits.underground", "Underground"],
  ace: ["tft:traits.ace", "Ace"],
  aegis: ["tft:traits.aegis", "Aegis"],
  defender: ["tft:traits.defender", "Defender"],
  forecaster: ["tft:traits.forecaster", "Forecaster"],
  hacker: ["tft:traits.hacker", "Hacker"],
  heart: ["tft:traits.heart", "Heart"],
  mascot: ["tft:traits.mascot", "Mascot"],
  prankster: ["tft:traits.prankster", "Prankster"],
  recon: ["tft:traits.recon", "Recon"],
  renegade: ["tft:traits.renegade", "Renegade"],
  spellslinger: ["tft:traits.spellslinger", "Spellslinger"],
  sureshot: ["tft:traits.sureshot", "Sureshot"],
  infiniteam: ["tft:traits.infiniteam", "Infiniteam"],
  quickdraw: ["tft:traits.quickdraw", "Quickdraw"],
  riftwalker: ["tft:traits.riftwalker", "Riftwalker"],
  parallel: ["tft:traits.parallel", "Parallel"],
  bastion: ["tft:traits.bastion", "Bastion"],
  darkin: ["tft:traits.darkin", "Darkin"],
  deadeye: ["tft:traits.deadeye", "Deadeye"],
  demacia: ["tft:traits.demacia", "Demacia"],
  empress: ["tft:traits.empress", "Empress"],
  freljord: ["tft:traits.freljord", "Freljord"],
  gunner: ["tft:traits.gunner", "Gunner"],
  ionia: ["tft:traits.ionia", "Ionia"],
  juggernaut: ["tft:traits.juggernaut", "Juggernaut"],
  multicaster: ["tft:traits.multicaster", "Multicaster"],
  noxus: ["tft:traits.noxus", "Noxus"],
  piltover: ["tft:traits.piltover", "Piltover"],
  redeemer: ["tft:traits.redeemer", "Redeemer"],
  rogue: ["tft:traits.rogue", "Rogue"],
  shadowisles: ["tft:traits.shadowisles", "Shadow Isles"],
  shurima: ["tft:traits.shurima", "Shurima"],
  strategist: ["tft:traits.strategist", "Strategist"],
  targon: ["tft:traits.targon", "Targon"],
  technogenius: ["tft:traits.technogenius", "Technogenius"],
  wanderer: ["tft:traits.wanderer", "Wanderer"],
  zaun: ["tft:traits.zaun", "Zaun"],
  bilgewater: ["tft:traits.bilgewater", "Bilgewater"],
  ixtal: ["tft:traits.ixtal", "Ixtal"],
  reaverking: ["tft:traits.reaverking", "Reaver King"],
  vanquisher: ["tft:traits.vanquisher", "Vanquisher"],
  "8bit": ["tft:traits.8bit", "8-bit"],
  breakout: ["tft:traits.breakout", "Breakout"],
  maestro: ["tft:traits.maestro", "Maestro"],
  country: ["tft:traits.country", "Country"],
  crowddiver: ["tft:traits.crowddiver", "Crowd Diver"],
  mixmaster: ["tft:traits.mixmaster", "Mixmaster"],
  bigshot: ["tft:traits.bigshot", "Big Shot"],
  edm: ["tft:traits.edm", "EDM"],
  edgelord: ["tft:traits.edgelord", "Edgelord"],
  emo: ["tft:traits.emo", "Emo"],
  mosher: ["tft:traits.mosher", "Mosher"],
  disco: ["tft:traits.disco", "Disco"],
  hyperpop: ["tft:traits.hyperpop", "Hyperpop"],
  illbeats: ["tft:traits.illbeats", "ILLBEATS"],
  jazz: ["tft:traits.jazz", "Jazz"],
  kda: ["tft:traits.kda", "K/DA"],
  pentakill: ["tft:traits.pentakill", "Pentakill"],
  heartsteel: ["tft:traits.heartsteel", "Heartsteel"],
  punk: ["tft:traits.punk", "Punk"],
  rapidfire: ["tft:traits.rapidfire", "Rapidfire"],
  superfan: ["tft:traits.superfan", "Superfan"],
  truedamage: ["tft:traits.truedamage", "True Damage"],
  wildcard: ["tft:traits.wildcard", "Wildcard"],
  dryad: ["tft:traits.dryad", "Dryad"],
  artist: ["tft:traits.artist", "Artist"],
  behemoth: ["tft:traits.behemoth", "Behemoth"],
  umbral: ["tft:traits.umbral", "Umbral"],
  heavenly: ["tft:traits.heavenly", "Heavenly"],
  storyweaver: ["tft:traits.storyweaver", "Storyweaver"],
  trickshot: ["tft:traits.trickshot", "Trickshot"],
  fated: ["tft:traits.fated", "Fated"],
  altruist: ["tft:traits.altruist", "Altruist"],
  lovers: ["tft:traits.lovers", "Lovers"],
  exalted: ["tft:traits.exalted", "Exalted"],
  porcelain: ["tft:traits.porcelain", "Porcelain"],
  great: ["tft:traits.great", "Great"],
  inkshadow: ["tft:traits.inkshadow", "Inkshadow"],
  spiritwalker: ["tft:traits.spiritwalker", "Spiritwalker"],
  mythic: ["tft:traits.mythic", "Mythic"],
  dragonlord: ["tft:traits.dragonlord", "Dragonlord"],
  ghostly: ["tft:traits.ghostly", "Ghostly"],
  reaper: ["tft:traits.reaper", "Reaper"],
  sage: ["tft:traits.sage", "Sage"],
  // set 13
  missmagetrait: ["tft:traits.missmagetrait", "Banished Mage"],
  ambusher: ["tft:traits.ambusher", "Ambusher"],
  family: ["tft:traits.family", "Family"],
  crime: ["tft:traits.crime", "Chem-Baron"],
  ambassador: ["tft:traits.ambassador", "Emissary"],
  automata: ["tft:traits.automata", "Automata"],
  watcher: ["tft:traits.watcher", "Watcher"],
  titan: ["tft:traits.titan", "Sentinel"],
  visionary: ["tft:traits.visionary", "Visionary"],
  squad: ["tft:traits.squad", "Enforcer"],
  pugilist: ["tft:traits.pugilist", "Pit Fighter"],
  formswapper: ["tft:traits.formswapper", "Form Swapper"],
  junkerking: ["tft:traits.junkerking", "Junker King"],
  experiment: ["tft:traits.experiment", "Experiment"],
  machineherald: ["tft:traits.machineherald", "Machine Herald"],
  cabal: ["tft:traits.cabal", "Black Rose"],
  highroller: ["tft:traits.highroller", "High Roller"],
  quickstriker: ["tft:traits.quickstriker", "Quickstriker"],
  warband: ["tft:traits.warband", "Conqueror"],
  hoverboard: ["tft:traits.hoverboard", "Firelight"],
  infused: ["tft:traits.infused", "Dominator"],
  martialist: ["tft:traits.martialist", "Artillerist"],
  bloodhunter: ["tft:traits.bloodhunter", "Blood Hunter"],
  betrayal: ["tft:traits.betrayal", "Betrayal"],
  bloodbrothers: ["tft:traits.bloodbrothers", "Blood Brothers"],
  geniuses: ["tft:traits.geniuses", "Geniuses"],
  menaces: ["tft:traits.menaces", "Menaces"],
  mentorship: ["tft:traits.mentorship", "Martial Law"],
  reunion: ["tft:traits.reunion", "Reunion"],
  sisters: ["tft:traits.sisters", "Sisters"],
  unlikelyduo: ["tft:traits.unlikelyduo", "Unlikely Duo"],
};

export const TRAIT_NAMES_FIX = {
  set2: {
    celestial: "Lunar",
    metal: "Steel",
    wind: "Cloud",
    forest: "Woodland",
  },
  set3: {},
  set4: {
    boss: "TheBoss",
    theboss: "TheBoss",
    wilderness: "Elderwood",
  },
  set4_5: {
    boss: "TheBoss",
    soulstealer: "Syphoner",
    theboss: "TheBoss",
    wilderness: "Elderwood",
  },
  set5: {},
  set6_5: {
    rivals: "Rival",
  },
  set8: {
    channeler: "Spellslinger",
    deadeye: "Sureshot",
    exoprime: "MechaPrime",
    genae: "Gadgeteen",
    spacecorps: "LaserCorps",
    undergroundthe: "Underground",
  },
  set9: {
    armorclad: "Juggernaut",
    bandlecity: "Yordle",
    marksman: "Gunner",
    preserver: "Invoker",
  },
};
TRAIT_NAMES_FIX.set9_5 = TRAIT_NAMES_FIX.set9;

export const STAT_MULTIPLIERS = [1, 1.8, 3.6];

export const SORT_SYMBOLS = stringsToSymbols([
  "tierSort",
  "pickRate",
  "avgPlacement",
  "top4",
  "winRate",
  "roundWinrate",
  "streakRate",
]);
export const SORT_TYPES = new SymbolMap({
  [SORT_SYMBOLS.tierSort]: {
    key: "tier",
    t: ["lol:tier", "Tier"],
  },

  [SORT_SYMBOLS.pickRate]: {
    key: "pick_rate",
    t: ["tft:pickRate", "Pick Rate"],
  },
  [SORT_SYMBOLS.avgPlacement]: {
    key: "avg_placement",
    t: ["common:avgPlace", "Avg. Place"],
  },
  [SORT_SYMBOLS.top4]: {
    key: "top_4_percent",
    t: ["tft:topFour", "Top 4"],
  },
  [SORT_SYMBOLS.winRate]: {
    key: "top_1_percent",
    t: ["tft:winRate", "Win Rate"],
  },
});
export const SORT_TYPES_EARLYCOMPS = new SymbolMap({
  [SORT_SYMBOLS.tierSort]: {
    key: "tier",
    t: ["lol:tier", "Tier"],
  },

  [SORT_SYMBOLS.pickRate]: {
    key: "pick_rate",
    t: ["tft:pickRate", "Pick Rate"],
  },
  [SORT_SYMBOLS.avgPlacement]: {
    key: "avg_placement",
    t: ["common:avgPlace", "Avg. Place"],
  },
  [SORT_SYMBOLS.roundWinrate]: {
    key: "round_winrate",
    t: ["tft:roundWinRate", "Round Win Rate"],
  },
  [SORT_SYMBOLS.streakRate]: {
    key: "streak_rate",
    t: ["tft:streak%", "Streak %"],
  },
});

export const POSTMATCH_UNIT_BLACKLIST = new Set(["Hexcore", "Augment"]);

export const TIER_TO_STAR_SVG = {
  2: `${appURLs.CDN_PLAIN}/blitz/ui/images/icons/TFT-StarSilver.svg`,
  3: `${appURLs.CDN_PLAIN}/blitz/ui/images/icons/TFT-StarGold.svg`,
  4: `${appURLs.CDN_PLAIN}/blitz/ui/images/icons/TFT-StarTurq.svg`,
};

export const ROLLING_CHANCES = {
  "level-1": {
    "cost-1": 1,
    "cost-2": 0,
    "cost-3": 0,
    "cost-4": 0,
    "cost-5": 0,
    "cost-6": 0,
    "cost-7": 0,
    "cost-8": 0,
    "cost-10": 0,
  },
  "level-2": {
    "cost-1": 1,
    "cost-2": 0,
    "cost-3": 0,
    "cost-4": 0,
    "cost-5": 0,
    "cost-6": 0,
    "cost-7": 0,
    "cost-8": 0,
    "cost-10": 0,
  },
  "level-3": {
    "cost-1": 0.75,
    "cost-2": 0.25,
    "cost-3": 0,
    "cost-4": 0,
    "cost-5": 0,
    "cost-6": 0,
    "cost-7": 0,
    "cost-8": 0,
    "cost-10": 0,
  },
  "level-4": {
    "cost-1": 0.55,
    "cost-2": 0.3,
    "cost-3": 0.15,
    "cost-4": 0,
    "cost-5": 0,
    "cost-6": 0,
    "cost-7": 0,
    "cost-8": 0,
    "cost-10": 0,
  },
  "level-5": {
    "cost-1": 0.45,
    "cost-2": 0.33,
    "cost-3": 0.2,
    "cost-4": 0.02,
    "cost-5": 0,
    "cost-6": 0,
    "cost-7": 0,
    "cost-8": 0,
    "cost-10": 0,
  },
  "level-6": {
    "cost-1": 0.3,
    "cost-2": 0.4,
    "cost-3": 0.25,
    "cost-4": 0.05,
    "cost-5": 0,
    "cost-6": 0,
    "cost-7": 0,
    "cost-8": 0,
    "cost-10": 0,
  },
  "level-7": {
    "cost-1": 0.19,
    "cost-2": 0.3,
    "cost-3": 0.4,
    "cost-4": 0.1,
    "cost-5": 0.01,
    "cost-6": 0,
    "cost-7": 0,
    "cost-8": 0,
    "cost-10": 0,
  },
  "level-8": {
    "cost-1": 0.17,
    "cost-2": 0.24,
    "cost-3": 0.32,
    "cost-4": 0.24,
    "cost-5": 0.03,
    "cost-6": 0,
    "cost-7": 0,
    "cost-8": 0,
    "cost-10": 0,
  },
  "level-9": {
    "cost-1": 0.15,
    "cost-2": 0.18,
    "cost-3": 0.25,
    "cost-4": 0.3,
    "cost-5": 0.12,
    "cost-6": 0,
    "cost-7": 0,
    "cost-8": 0,
    "cost-10": 0,
  },
  "level-10": {
    "cost-1": 0.05,
    "cost-2": 0.1,
    "cost-3": 0.2,
    "cost-4": 0.4,
    "cost-5": 0.25,
    "cost-6": 0,
    "cost-7": 0,
    "cost-8": 0,
    "cost-10": 0,
  },
  "level-11": {
    "cost-1": 0.01,
    "cost-2": 0.02,
    "cost-3": 0.12,
    "cost-4": 0.5,
    "cost-5": 0.35,
    "cost-6": 0,
    "cost-7": 0,
    "cost-8": 0,
    "cost-10": 0,
  },
};

export const TOTAL_UNIT_COPIES = {
  "cost-1": 30,
  "cost-2": 25,
  "cost-3": 18,
  "cost-4": 10,
  "cost-5": 9,
  "cost-6": 17,
  "cost-7": 12,
  "cost-8": 10,
  "cost-10": 9,
};

export const UNBUYABLE_CHAMPS = [
  "BabyDragon",
  "Daisy",
  "DraconicEgg",
  "TheMonstrosity",
  "TrainingDummy",
  "Voidspawn",
  "Wolf",
  "MechanicalScarab",
  "MechanicalBear",
  "MechanicalDragon",
  "MalzaharVoidling",
  "Tibbers",
  "HexTechDragon",
  "JadeStatue",
  "HeimerdingerTurret",
  "THex",
  "RyzeBandleCity",
  "RyzeDemacia",
  "RyzeFreljord",
  "RyzeIonia",
  "RyzeNoxus",
  "RyzePiltover",
  "RyzeShadowIsles",
  "RyzeShurima",
  "RyzeTargon",
  "RyzeZaun",
  "TFT11_Kayle",
  "Tainted Golem",
  "Dark Monolith",
  "Many-Eyed Beast",
  "Stormbringer",
  "Yuumi",
];

export const SUGGESTED_ITEMS = [
  "zephyr",
  "shroudofstillness",
  "rocketpropelledfist",
  "mistral",
];
export const regionToLanguage = {
  en: "en_US",
  de: "de_DE",
  es: "es_ES",
  fr: "fr_FR",
  it: "it_IT",
  pt: "pt_BR",
  tr: "tr_TR",
  pl: "pl_PL",
  ru: "ru_RU",
  cs: "cs_CZ",
  cz: "cs_CZ",
  el: "el_GR",
  gr: "el_GR",
  ko: "ko_KR",
  kr: "ko_KR",
  ja: "ja_JP",
  jp: "ja_JP",
  vi: "vi_VN",
  vn: "vi_VN",
  "zh-Hans-CN": "zh_CN",
  "zh-Hant-TW": "zh_TW",
};
export const DEFAULT_LOCALE = "en_US";

export const TOGGLES_CHAMPION = "CHAMPION";
export const TOGGLES_LOADED_DICE = "LOADED_DICE";
export const TOGGLE_TRANSLATIONS = {
  [TOGGLES_CHAMPION]: ["lol:champion_plural", "Champions"],
  [TOGGLES_LOADED_DICE]: ["tft:loadedDice", "Loaded Dice"],
};

export const PORTAL_BLACKLIST = {
  set9: ["TFT9_RegionPortals_TheLavenderSea", "TFT9_RegionPortals_TheRupture"],
  set9_5: [],
};

export const TRAIT_BLACKLIST = {
  set11: ["TFT11_TrickshotAltruist"],
};

export const LEVELING_METHODS = {
  standard: {
    name: ["tft:leveling.standard", "Standard"],
    description: [
      "tft:leveling.standardDescription",
      "Focus on hitting gold thresholds while keeping up with the pace of the lobby.",
    ],
    leveling: {
      lvl4: [
        "Lvl  <b>4</b>  by  <b>2-1</b>",
        ["tft:leveling.saveGold", "Save Gold"],
      ],
      lvl5: [
        "Lvl  <b>5</b>  by  <b>2-5</b>",
        ["tft:leveling.saveGold", "Save Gold"],
      ],
      lvl6: [
        "Lvl  <b>6</b>  by  <b>3-2</b>",
        ["tft:leveling.stabilizeStay20g", "Stabilize (Stay 20g+)"],
      ],
      lvl7: [
        "Lvl  <b>7</b>  by  <b>4-1</b>",
        ["tft:leveling.stabilizeStay20g", "Stabilize (Stay 20g+)"],
      ],
      lvl8: [
        "Lvl  <b>8</b>  by  <b>5-1</b>",
        ["tft:leveling.finalUpgradesLevel", "Final Upgrades / Level"],
      ],
    },
  },
  roll_5: {
    name: ["tft:leveling.slowroll5", "Slowroll - Lvl 5"],
    description: [
      "tft:leveling.slowroll5Description",
      "Don't level up! Try to <span>3 star</span> champions at <b>Lvl 5</b> by rolling your excess gold and staying above 50g.",
    ],
    leveling: {
      lvl4: [
        "Lvl  <b>4</b>  by  <b>2-3</b>",
        ["tft:leveling.reach10g", "Reach 10g"],
      ],
      lvl5: [
        "Lvl  <b>5</b>  by  <b>3-1</b>",
        ["tft:leveling.slowroll3star", "Slowroll For 3 Star"],
      ],
      lvl6: [
        "Lvl  <b>6</b>  by  <b>4-1</b>",
        ["tft:leveling.finalUpgradesLevel", "Final Upgrades / Level"],
      ],
      lvl7: [
        "Lvl  <b>7/8  ASAP</b>",
        ["tft:leveling.econ50glevel", "Econ to 50g & Level"],
      ],
    },
  },
  roll_6: {
    name: ["tft:leveling.slowroll6", "Slowroll - Lvl 6"],
    description: [
      "tft:leveling.slowroll6Description",
      "Try to <span>3 star</span> champions at <b>Lvl 6</b> by rolling excess gold and staying above 50g.",
    ],
    leveling: {
      lvl4: [
        "Lvl  <b>4</b>  by  <b>2-1</b>",
        ["tft:leveling.saveGold", "Save Gold"],
      ],
      lvl5: [
        "Lvl  <b>5</b>  by  <b>2-5</b>",
        ["tft:leveling.saveGold", "Save Gold"],
      ],
      lvl6: [
        "Lvl  <b>6</b>  by  <b>3-2</b>",
        ["tft:leveling.stabilizeSlowroll", "Stabilize / Slowroll"],
      ],
      lvl7: [
        "Lvl  <b>7</b>  by  <b>5-3</b>",
        ["tft:leveling.finalUpgradesLevel", "Final Upgrades / Level"],
      ],
      lvl8: [
        "Lvl  <b>8  ASAP</b>",
        ["tft:leveling.econ50glevel", "Econ to 50g & Level"],
      ],
    },
  },
  roll_7: {
    name: ["tft:leveling.slowroll7", "Slowroll - Lvl 7"],
    description: [
      "tft:leveling.slowroll7Description",
      "Try to <span>3 star</span> champions at <b>Lvl 7</b> by rolling excess gold and staying above 50g.",
    ],
    leveling: {
      lvl4: [
        "Lvl  <b>4</b>  by  <b>2-1</b>",
        ["tft:leveling.saveGold", "Save Gold"],
      ],
      lvl5: [
        "Lvl  <b>5</b>  by  <b>2-5</b>",
        ["tft:leveling.saveGold", "Save Gold"],
      ],
      lvl6: [
        "Lvl  <b>6</b>  by  <b>3-2</b>",
        ["tft:leveling.stabilizeStay20g", "Stabilize (Stay 20g+)"],
      ],
      lvl7: [
        "Lvl  <b>7</b>  by  <b>4-1</b>",
        ["tft:leveling.stabilizeSlowroll", "Stabilize / Slowroll"],
      ],
      lvl8: [
        "Lvl  <b>8</b>  by  <b>5-5</b>",
        ["tft:leveling.finalUpgradesLevel", "Final Upgrades / Level"],
      ],
    },
  },
  fast_8: {
    name: ["tft:leveling.fast8", "Fast 8"],
    description: [
      "tft:leveling.fast8Description",
      "Try to <span>2 star</span> champions at <b>Lvl 8</b> by rolling.",
    ],
    leveling: {
      lvl4: [
        "Lvl  <b>4</b>  by  <b>2-1</b>",
        ["tft:leveling.saveGold", "Save Gold"],
      ],
      lvl5: [
        "Lvl  <b>5</b>  by  <b>2-5</b>",
        ["tft:leveling.saveGold", "Save Gold"],
      ],
      lvl6: [
        "Lvl  <b>6</b>  by  <b>3-2</b>",
        ["tft:leveling.saveGold", "Save Gold"],
      ],
      lvl7: [
        "Lvl  <b>7</b>  by  <b>4-1</b>",
        ["tft:leveling.stabilizeStay20g", "Stabilize (Stay 20g+)"],
      ],
      lvl8: [
        "Lvl  <b>8 ASAP</b>",
        ["tft:leveling.slowrollFinalUpgrades", "Slowroll / Final Upgrades"],
      ],
    },
  },
  fast_9: {
    name: ["tft:leveling.fast9", "Fast 9"],
    description: [
      "tft:leveling.fast9Description",
      "Try to <span>2 star</span> champions at <b>Lvl 9</b> by rolling.",
    ],
    leveling: {
      lvl4: [
        "Lvl  <b>4</b>  by  <b>2-1</b>",
        ["tft:leveling.saveGold", "Save Gold"],
      ],
      lvl5: [
        "Lvl  <b>5</b>  by  <b>2-5</b>",
        ["tft:leveling.saveGold", "Save Gold"],
      ],
      lvl6: [
        "Lvl  <b>6</b>  by  <b>3-2</b>",
        ["tft:leveling.saveGold", "Save Gold"],
      ],
      lvl7: [
        "Lvl  <b>7</b>  by  <b>4-1</b>",
        ["tft:leveling.stabilizeStay20g", "Stabilize (Stay 20g+)"],
      ],
      lvl8: [
        "Lvl  <b>8</b>  by  <b>5-1</b>",
        ["tft:leveling.stabilizeStay20g", "Stabilize (Stay 20g+)"],
      ],
      lvl9: [
        "Lvl  <b>9 ASAP</b>",
        ["tft:leveling.slowrollFinalUpgrades", "Slowroll / Final Upgrades"],
      ],
    },
  },
  fast_10: {
    name: ["tft:leveling.fast10", "Fast 10"],
    description: [
      "tft:leveling.fast10Description",
      "Try to reach <b>Lvl 10</b> as soon as possible.",
    ],
    leveling: {
      lvl4: [
        "Lvl  <b>4</b>  by  <b>2-1</b>",
        ["tft:leveling.saveGold", "Save Gold"],
      ],
      lvl5: [
        "Lvl  <b>5</b>  by  <b>2-5</b>",
        ["tft:leveling.saveGold", "Save Gold"],
      ],
      lvl6: [
        "Lvl  <b>6</b>  by  <b>3-2</b>",
        ["tft:leveling.saveGold", "Save Gold"],
      ],
      lvl7: [
        "Lvl  <b>7</b>  by  <b>3-5</b>",
        ["tft:leveling.saveGold", "Save Gold"],
      ],
      lvl8: [
        "Lvl  <b>8</b>  by  <b>4-1</b>",
        ["tft:leveling.stabilizeStay20g", "Stabilize (Stay 20g+)"],
      ],
      lvl9: [
        "Lvl  <b>9</b>  by  <b>5-1</b>",
        ["tft:leveling.stabilizeStay20g", "Stabilize (Stay 20g+)"],
      ],
      lvl10: [
        "Lvl  <b>10 ASAP</b> ",
        ["tft:leveling.finalUpgrades", "Final Upgrades"],
      ],
    },
  },
};

export const GAME_MODES_STANDARD = {
  ranked: ["tft:queues.ranked", "Ranked"],
  normal: ["tft:queues.normal", "Normal"],
};
export const GAME_MODES_MISC = {
  doubleup: ["tft:queues.doubleup", "Double Up"],
  // tockersTrials: ["tft:queues.tockersTrials", "Tocker's Trials"],
};

export const placementAverage = 4.5;

export const TEMP_MODE = "REVIVAL";

export const championNameMap = {
  TFT_TrainingDummy: "TrainingDummy",
  TFT_ItemUnknown: "TrainingDummy",
  LeBlanc: "Leblanc",
  Wukong: "WuKong",
  ChoGath: "Chogath",
  Kaisa: "KaiSa",
  KhaZix: "Khazix",
  BelVeth: "Belveth",
  DragonGreen: "ShiOhYu",
  DragonPurple: "Syfen",
  DragonGold: "Idas",
  DragonBlue: "Daeja",
  AquaticDragon: "Sohm",
  DragonSwain: "SwainDragonTyrant",
  DragonGuild: "Zippy",
  DragonEarth: "Terra",
  NomsyCannoneer: "TrainerDragon",
  NomsyMage: "TrainerDragon",
  NomsyEvoker: "TrainerDragon",
  EzrealFuture: "UltimateEzreal",
  GnarBig: "Gnar",
  VelKoz: "Velkoz",
  reksai: "RekSai",
  Reksai: "RekSai",
  tft9_reksai: "RekSai",
  Akali_TrueDamage: "Akali",
};

export const showAugmentStats = true;
export const showAugmentOverlay = false;
export const setsWithoutPortals = ["set13", "set14", "set15"];
